import { render, staticRenderFns } from "./Leads.vue?vue&type=template&id=8cd84e78&"
import script from "./Leads.vue?vue&type=script&lang=js&"
export * from "./Leads.vue?vue&type=script&lang=js&"
import style0 from "./Leads.vue?vue&type=style&index=0&id=8cd84e78&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports